import { selectRequestByType } from 'ducks/requests/selectors'
import { FETCH_CUSTOMER_RATING_SETTINGS } from '../types'

export const selectHasLoadedCustomerRatingSettings = state =>
  selectRequestByType(state, FETCH_CUSTOMER_RATING_SETTINGS).loaded
